import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=b0ca9144"
import script from "./HomeProducts.vue?vue&type=script&lang=js"
export * from "./HomeProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageLoading: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ImageLoading.vue').default,SectionContainer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/SectionContainer.vue').default})
